import { AppUppyFile } from "common";
import { RequiredDocumentMeta } from "../../model/application-form.model";

export enum UppyFileChangeTypeEnum {
  Added = 'added',
  Removed = 'removed',
  Canceled = "canceled",
  Closed = "closed"
}

export interface UploadFileDialogResult {
  type: UppyFileChangeTypeEnum;
  files: AppUppyFile[];
}

export interface UploadFileDialogConfig {
  maxNumberOfFiles: number;
  accessToken?: string;
  endpoint?: string;
  files?: any[];
  getMetaCallback?: (data: UploadFileDialogConfig) => RequiredDocumentMeta;
}
